export enum FrageFuehrerschein {
  KEINE_PRAEFERENZ = 'keine_praeferenz',

  NICHT_ERFORDERLICH = 'nicht_erforderlich',

  MIT_FAHRPRAXIS = 'mit_fahrpraxis',
}
